export default "/icon_del.0de08320-491246.png";